import type { PublicUser } from '@breakoutlearning/firebase-repository/models/PublicUser'
import { BreakoutUserAvatar } from 'components/breakout/BreakoutUserAvatar'
import { BreakoutPill } from 'components/design-system/BreakoutPill'
import type { SelectOption } from 'components/design-system/BreakoutSelect'

export function InstructorSelectOption({
  instructor,
  text,
  value,
  disabled,
  count,
  avatarSize = 'medium',
}: {
  instructor?: PublicUser
  text: string
  value: string
  disabled?: boolean
  count?: number
  avatarSize?: 'small' | 'medium'
}): SelectOption<string> {
  return {
    label: (
      <div className="flex flex-row items-center justify-between gap-1.5">
        <div className="flex min-w-0 flex-row items-center gap-1.5">
          {instructor && (
            <div className="shrink-0">
              <BreakoutUserAvatar
                user={instructor}
                size={avatarSize}
                disabled={disabled}
              />
            </div>
          )}
          <BreakoutPill
            kind="transparent"
            label={text}
            className="!pl-0"
            disabled={disabled}
          />
        </div>
        {count && (
          <strong className="shrink-0 text-label-small text-on-surface-var">
            {count}
          </strong>
        )}
      </div>
    ),
    disabled,
    selectedLabel: (
      <div className="flex flex-row items-center gap-1.5">
        {instructor && (
          <div className="shrink-0">
            <BreakoutUserAvatar
              user={instructor}
              size={avatarSize}
              disabled={disabled}
            />
          </div>
        )}
        <BreakoutPill
          kind="transparent"
          label={text}
          className="!pl-0"
          disabled={disabled}
        />
      </div>
    ),
    value,
  }
}
